import { CSVReader } from 'react-papaparse';
import {  useState, useCallback, useMemo, useEffect } from 'react';
import useVariantStore from '../../../../zustand/useVariantStore';

import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {
  createColumnHelper,
  useReactTable,
  flexRender,
  getCoreRowModel,
} from '@tanstack/react-table';
import { Row } from '@shadcn/components/ui/row';
import { Col } from '@shadcn/components/ui/col';
import { Button } from '@shadcn/components/ui/button';
import { Input } from '@shadcn/components/ui/input';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@shadcn/components/ui/select';




import { ScrollArea } from '@shadcn/components/ui/scroll-area';
import { Card, CardContent } from '@shadcn/components/ui/card';
import { Popover, PopoverContent, PopoverTrigger } from '@shadcn/components/ui/popover';
import { uploadFileS3Bucket } from '@utilities/uploadFileS3Bucket';
import useProductStore from '../../../../zustand/useProductStore';
import { useParams } from 'react-router-dom';
import superagent from 'superagent';
import { backendUrl } from '@helpers/consts';

const columnHelper = createColumnHelper();

const INITIAL_FORM_STATE = {
  id: '',
  name: '',
  sku: '',
  image: '',
  color: '',
  is_archived: false,
  no_reorder: false,
  average_cog_au: 0,
  average_cog_us: 0,
  average_cog_uk: 0,
};


const BulkInputSKUsStep = () => {
  const { productID } = useParams();
  const { setVariants, variants, deletedVariants, hasExistingSKUs, setHasExistingSKUs, skusValidated, setSkusValidated } = useVariantStore((state) => ({
    setVariants: state.setVariants,
    variants: state.variants,
    deletedVariants: state.deletedVariants,
    hasExistingSKUs: state.hasExistingSKUs,
    setHasExistingSKUs: state.setHasExistingSKUs,
    skusValidated: state.skusValidated,
    setSkusValidated: state.setSkusValidated
  }));
  
  const { setImages, setSelectedImage, images, selectedImage, colorOptions, setColorOptions } = useProductStore((state) => ({
    setImages: state.setImages,
    setSelectedImage: state.setSelectedImage,
    images: state.images,
    selectedImage: state.selectedImage,
    colorOptions: state.colorOptions,
    setColorOptions: state.setColorOptions
  }));

  const [errors, setErrors] = useState({});
  const [formData, setFormData] = useState(INITIAL_FORM_STATE);
  const [editingIndex, setEditingIndex] = useState(null);
  const [isImageSelectorOpen, setIsImageSelectorOpen] = useState(false);
  const [showNewColor, setShowNewColor] = useState(false);
  const [newColor, setNewColor] = useState('');

  const [isValidatingSKUs, setIsValidatingSKUs] = useState(false);
  const [invalidSKUs, setInvalidSKUs] = useState([]);
  const [isAddingVariant, setIsAddingVariant] = useState(false);
  
  
  useEffect(() => {
    superagent.get(`${backendUrl}/dropdown/color`)
      .set('Authorization', `Bearer ${localStorage.getItem("authJWT")}`)
      .set('accept', 'json')
      .then(response => {
        if(response.status < 400) {
          setColorOptions(response.body);
        }
      })
      .catch(err => {
        console.error("Error fetching colors:", err);
      });
  }, [setColorOptions]);

 
  useEffect(() => {
    setSkusValidated(false);
    setInvalidSKUs([]);
    setHasExistingSKUs(false);
  }, [variants, setHasExistingSKUs, setSkusValidated]);

  const handleSaveColor = () => {
    if (!newColor) return;

    superagent.post(`${backendUrl}/dropdown/color`)
      .send({ value: newColor, label: newColor })
      .set('Authorization', `Bearer ${localStorage.getItem("authJWT")}`)
      .set('accept', 'json')
      .then(response => {
        if(response.status > 400){

        } else {
          superagent.get(`${backendUrl}/dropdown/color`)
            .set('Authorization', `Bearer ${localStorage.getItem("authJWT")}`)
            .set('accept', 'json')
            .then(fetchResponse => {
              if(fetchResponse.status < 400) {
                setColorOptions(fetchResponse.body);

                setTimeout(() => {
                  setFormData(prev => ({...prev, color: response.body.value}));
                }, 100);

                setShowNewColor(false);
                setNewColor('');
              }
            });
        }
      });
  };

  
  const isDuplicateInCurrentList = (sku, excludeIndex = null) => {
    return variants.some((variant, index) =>
      variant.sku.toLowerCase().trim() === sku.toLowerCase().trim() &&
      index !== excludeIndex
    );
  };

  const checkSKUExists = async (sku) => {
    if (!sku || sku.trim() === '') return false;

    try {
      const response = await superagent
        .post(`${backendUrl}/product/check-sku`)
        .send({ skus: [sku.trim()] })
        .set('Authorization', `Bearer ${localStorage.getItem("authJWT")}`)
        .set('accept', 'json');

      if (response.status < 400) {
        const result = response.body.results[0];
        return result && result.exists;
      }
    } catch (error) {
      console.error('Error checking SKU:', error);
    }
    return false;
  };

  const validateSKUs = async () => {
    const allSKUs = variants.map(variant => variant.sku).filter(sku => sku && sku.trim() !== '');

    if (allSKUs.length === 0) {
      return;
    }

    setIsValidatingSKUs(true);

    try {
      const response = await superagent
        .post(`${backendUrl}/product/check-sku`)
        .send({ skus: allSKUs })
        .set('Authorization', `Bearer ${localStorage.getItem("authJWT")}`)
        .set('accept', 'json');

      if (response.status < 400) {
        const existingSKUs = response.body.results
          .filter(result => result.exists)
          .map(result => result.sku);

        setInvalidSKUs(existingSKUs);
        setSkusValidated(true);

        if (existingSKUs.length > 0) {
          setHasExistingSKUs(true);
        } else {
          setHasExistingSKUs(false);
        }
      }
    } catch (error) {
      console.error('Error validating SKUs:', error);
    } finally {
      setIsValidatingSKUs(false);
    }
  };

  const handleImageUpload = useCallback(async (e) => {
    e.stopPropagation();
    const files = Array.from(e.target.files);
    
    try {
      const uploadedImages = await Promise.all(
        files.map(file => uploadFileS3Bucket(file, `product_image_${Date.now()}`))
      );

      setImages([...images, ...uploadedImages]);
      
      if(productID) {
        await superagent
          .put(`${backendUrl}/product/addImages/${productID}`)
          .send({ images: uploadedImages })
        .set('Authorization', `Bearer ${localStorage.getItem('authJWT')}`)
        .set('accept', 'json')
          .then(() => {

          });
      }
      
      
      e.target.value = '';
    } catch (error) {
      console.error('Error uploading images:', error);
    }
  }, [images, setImages, productID]);

  const validateVariant = useCallback((variant) => {
    const errors = {};
    if (!variant.name?.trim()) errors.name = 'Name is required';
    if (!variant.sku?.trim()) {
      errors.sku = 'SKU is required';
    } else {
      const skuRegex = /^[A-Z0-9-]+$/;
      if (!skuRegex.test(variant.sku)) {
        errors.sku = 'SKU must be uppercase letters, numbers and hyphens only, no spaces';
      }
    }

    return errors;
  }, []);

  const handleInputChange = useCallback((e) => {
    const { name, value, type, checked } = e.target;
    let processedValue = value;


    if (name === 'sku') {
      processedValue = value.toUpperCase().replace(/\s/g, '');
    }

    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : processedValue
    }));
    setErrors(prev => ({...prev, [name]: ''}));

    
    
    if (name === 'sku' && processedValue.trim()) {
      if (isDuplicateInCurrentList(processedValue, editingIndex)) {
        setErrors(prev => ({...prev, sku: 'SKU already exists in current list'}));
      }
    }
  }, [variants, editingIndex]);

  const handleImageSelect = useCallback((image) => {
    setSelectedImage(image);
    setFormData(prev => ({...prev, image}));
  }, [setSelectedImage]);

  const resetForm = useCallback(() => {
    setFormData({...INITIAL_FORM_STATE, id: ''});
    setEditingIndex(null);
  }, []);

  const handleFormSubmit = useCallback(async (e) => {
    e.preventDefault();

    if (isAddingVariant) return;

    const validationErrors = validateVariant(formData);

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    setIsAddingVariant(true);

    try {
      
      if (isDuplicateInCurrentList(formData.sku, editingIndex)) {
        setErrors({ sku: 'SKU already exists in current list' });
        return;
      }

      
      const skuExists = await checkSKUExists(formData.sku);
      if (skuExists) {
        setErrors({ sku: 'SKU already exists in database' });
        return;
      }

      const newVariant = {
        ...formData,
        id: formData.id || `variant_${Date.now()}_${Math.random().toString(36).substring(2, 11)}`
      };

      if (editingIndex !== null) {
        const updated = [...variants];
        updated[editingIndex] = newVariant;
        setVariants(updated);
      } else {
        setVariants([...variants, newVariant]);
      }

      resetForm();
    } catch (error) {
      console.error('Error adding variant:', error);
      setErrors({ general: 'Error adding variant. Please try again.' });
    } finally {
      setIsAddingVariant(false);
    }
  }, [formData, editingIndex, validateVariant, setVariants, resetForm, isAddingVariant, checkSKUExists]);

  const handleDelete = useCallback((variantId) => {
    const deleted = variants.find(v => v.id === variantId);
    if (deleted) {
      deletedVariants.push(deleted);
      setVariants(variants.filter(v => v.id !== variantId));
    }
  }, [variants, setVariants, deletedVariants]);

  const handleEdit = useCallback((variant, index) => {
    setFormData(variant);
    setEditingIndex(index);
  }, []);

  const handleOnDrop = (data) => {
    const uploadedVariants = [];
    const errorRows = [];
    const existingSKUs = new Set(variants.map(v => v.sku.toLowerCase().trim()));

    data.forEach((row, index) => {
      if (index === 0) return; // Skip header

      const item = row.data;
      if (item.length === 1) return; 

      const variant = updateVariantFromCsv(item);
      const validationErrors = validateVariant(variant);

      
      const skuLower = variant.sku.toLowerCase().trim();
      const isDuplicate = existingSKUs.has(skuLower) || 
                         uploadedVariants.some(v => v.sku.toLowerCase().trim() === skuLower);

      if (isDuplicate) {
        errorRows.push(`Row ${index + 1}: SKU "${variant.sku}" already exists`);
      } else if (Object.keys(validationErrors).length > 0) {
        errorRows.push(`Row ${index + 1}: ${Object.values(validationErrors).join(', ')}`);
      } else {
        uploadedVariants.push(variant);
        existingSKUs.add(skuLower);
      }
    });

    
    if (errorRows.length > 0) {
      toast.error(`CSV import errors: ${errorRows.join('; ')}`);
    }

    
    if (uploadedVariants.length > 0) {
      setVariants([...variants, ...uploadedVariants]);
      toast.success(`Successfully imported ${uploadedVariants.length} variants`);
    }
  };

  const ImageSelector = () => (
    <Popover open={isImageSelectorOpen} onOpenChange={setIsImageSelectorOpen}>
      <PopoverTrigger asChild>
        <Button variant="outline" className="w-full">
          {selectedImage ? 'Change Image' : 'Select Image'}
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-[400px] z-[1600] p-0" align="start" style={{maxHeight: '80vh', overflowY: 'auto'}}>
        <div className="p-4 space-y-4">
          <div className="flex justify-between items-center">
            <h4 className="text-sm font-medium">Product Images</h4>
            <label 
              className="cursor-pointer bg-blue-500 text-white px-3 py-1 rounded text-sm hover:bg-blue-600"
              onClick={(e) => e.stopPropagation()}
            >
              Upload New
              <input 
                type="file" 
                className="hidden" 
                accept="image/*"
                multiple
                onChange={handleImageUpload}
                onClick={(e) => e.stopPropagation()}
              />
            </label>
          </div>
          
          <ScrollArea className="h-[300px]">
            <div className="grid grid-cols-2 gap-2 p-2">
              { images?.length > 0 && images.map((image, index) => (
                <Card 
                  key={index}
                  className={`cursor-pointer transition-all ${selectedImage === image ? 'ring-2 ring-blue-500' : ''}`}
                  onClick={() => {
                    handleImageSelect(image);
                    setIsImageSelectorOpen(false);
                  }}
                >
                  <CardContent className="p-1">
                    <img 
                      src={image} 
                      alt={`Product ${index + 1}`}
                      className="w-full h-24 object-cover rounded"
                    />
                  </CardContent>
                </Card>
              ))}
            </div>
          </ScrollArea>
        </div>
      </PopoverContent>
    </Popover>
  );

  

  

  const updateVariantFromCsv = (item) => {
    const [
      name,
      sku,
      image,
      color,
    ] = item;

    return {
      id: `variant_${Date.now()}_${Math.random().toString(36).substring(2, 11)}`,
      name: name || '',
      sku: (sku || '').toUpperCase().replace(/\s/g, ''),
      image: image || '',
      color: color || '',
      average_cog_au: 0,
      average_cog_us: 0,
      average_cog_uk: 0,
      is_archived: false,
      no_reorder: false,
    }
  }

  const columns = useMemo(() => [
    columnHelper.accessor('name', {
      header: 'Name'
    }),
    columnHelper.accessor('sku', {
      header: 'SKU',
      cell: ({ row }) => {
        const isInvalid = invalidSKUs.includes(row.original.sku);
        return (
          <div className={`flex items-center gap-2 ${isInvalid ? 'text-red-600 font-medium' : ''}`}>
            <span>{row.original.sku}</span>
            {isInvalid && (
              <span className="text-red-500" title="SKU already exists">
                ❌
              </span>
            )}
          </div>
        );
      }
    }),
    columnHelper.accessor('image', {
      header: 'Image',
      cell: ({ row }) => (
        row.original.image ? 
        <img src={row.original.image} alt={row.original.name} className="w-16 h-16 object-cover rounded" /> :
        'No image'
      )
    }),
    columnHelper.accessor('color', {
      header: 'Color'
    }),

    columnHelper.accessor('actions', {
      header: 'Actions',
      cell: ({ row }) => (
        <div className="flex gap-2">

          <button 
            onClick={() => handleEdit(row.original, row.index)}
            className="text-blue-500 hover:text-blue-700"
          >
            <i className="bx bx-pencil"></i>
          </button>
          {!row.original._id && (
            <button 
              onClick={() => handleDelete(row.original.id)}
              className="text-red-500 hover:text-red-700"
          >
              <i className="bx bx-trash"></i>
            </button>
          )}
        </div>
      )
    }),
  ], [handleEdit, handleDelete, invalidSKUs]);

  const table = useReactTable({
    data: variants,
    columns,
    getCoreRowModel: getCoreRowModel(),
  });



  return (
    <Row>
      <Col>
        <div className="flex flex-col gap-8 max-w-6xl mx-auto">
          <div className="bg-white shadow rounded-lg p-6">
            <h3 className="text-xl font-semibold mb-6">Upload CSV</h3>
            
            <CSVReader onDrop={handleOnDrop}>
              <div className="border-2 border-dashed border-gray-300 rounded-lg p-8 text-center hover:border-blue-500 transition-colors">
                <span className="text-gray-600">
                  Drop CSV file here or click to upload.
                </span>
              </div>
              
            </CSVReader>
            <div className="mt-2 text-center">
              <p className="text-sm text-gray-600 mb-2">
                CSV format: Name, SKU, Image URL, Color
              </p>
              <a
                target="_blank"
                href="https://docs.google.com/spreadsheets/d/1YouX8Sbz8KP11EbCUf56H9AxIcXmMiIhcM6MneCGMxw/copy"
                className="text-blue-500 hover:text-blue-700 underline"
              >
                CSV Template
              </a>
            </div>


          </div>

          <div className="bg-white shadow rounded-lg p-6">
            <h3 className="text-xl font-semibold mb-6">Manual Input</h3>
            <form onSubmit={handleFormSubmit} className="space-y-6">
              
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div className="flex flex-col">
                  <label className="text-sm font-medium mb-1">Name</label>
                  <Input
                    name="name"
                    value={formData.name}
                    onChange={handleInputChange}
                    className={`w-full ${errors.name ? 'border-red-500' : ''}`}
                  />
                  {errors.name && (
                    <span className="text-red-500 text-sm mt-1">
                      {errors.name}
                    </span>
                  )}
                </div>
                <div className="flex flex-col">
                  <label className="text-sm font-medium mb-1">SKU</label>
                  <Input
                    name="sku"
                    value={formData.sku}
                    onChange={handleInputChange}
                    className={`w-full ${errors.sku ? 'border-red-500' : ''}`}
                  />
                  {errors.sku && (
                    <span className="text-red-500 text-sm mt-1">
                      {errors.sku}
                    </span>
                  )}
                </div>
              </div>

              
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div className="flex flex-col">
                  <label className="text-sm font-medium mb-1">Color</label>
                  {!showNewColor ? (
                    <div className="flex gap-2">
                      <Select
                        value={formData.color || ''}
                        onValueChange={(value) => {
                          setFormData(prev => ({...prev, color: value}));
                          setErrors(prev => ({...prev, color: ''}));
                        }}
                      >
                        <SelectTrigger className="flex-1">
                          <SelectValue placeholder="Select Color" />
                        </SelectTrigger>
                        <SelectContent className="max-h-[200px] overflow-y-auto z-[99999]" position="popper" sideOffset={4}>
                          {colorOptions.map((option) => (
                            <SelectItem key={option.value} value={option.value}>
                              {option.label}
                            </SelectItem>
                          ))}
                        </SelectContent>
                      </Select>
                      <Button
                        type="button"
                        variant="outline"
                        onClick={() => setShowNewColor(true)}
                        className="px-3"
                      >
                        Add New
                      </Button>
                    </div>
                  ) : (
                    <div className="space-y-2">
                      <Input
                        value={newColor}
                        onChange={(e) => setNewColor(e.target.value)}
                        placeholder="Enter new color name"
                      />
                      <div className="flex gap-2">
                        <Button
                          type="button"
                          variant="outline"
                          onClick={() => setShowNewColor(false)}
                          className="flex-1"
                        >
                          Cancel
                        </Button>
                        <Button
                          type="button"
                          className="flex-1"
                          onClick={handleSaveColor}
                        >
                          Save
                        </Button>
                      </div>
                    </div>
                  )}
                  {errors.color && (
                    <span className="text-red-500 text-sm mt-1">
                      {errors.color}
                    </span>
                  )}
                </div>
                <div className="flex flex-col">
                  <label className="text-sm font-medium mb-1">Image</label>
                  <ImageSelector />
                </div>
              </div>

              {errors.general && (
                <div className="text-red-500 text-sm text-center">
                  {errors.general}
                </div>
              )}

              <div className="flex justify-end">
                <Button
                  type="submit"
                  className="px-8"
                  disabled={isAddingVariant}
                >
                  {isAddingVariant ? (
                    <div className="flex items-center gap-2">
                      <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white"></div>
                      {editingIndex !== null ? 'Updating...' : 'Adding...'}
                    </div>
                  ) : (
                    editingIndex !== null ? 'Update Variant' : 'Add Variant'
                  )}
                </Button>
              </div>
            </form>
          </div>
        </div>

        <div className="overflow-x-auto max-w-[55vw] py-10">
          <div className="bg-white shadow rounded-lg p-6">
            <div className="flex justify-between items-center mb-4">
              <h3 className="text-lg font-semibold">Variants List ({variants.length})</h3>
              <div className="flex gap-3 items-center">
                <Button
                  onClick={validateSKUs}
                  disabled={isValidatingSKUs || variants.length === 0}
                  variant={skusValidated && !hasExistingSKUs ? "default" : "outline"}
                >
                  {isValidatingSKUs ? 'Validating...' : skusValidated ? (hasExistingSKUs ? 'Re-validate SKUs' : '✓ SKUs Valid') : 'Validate SKUs'}
                </Button>
                {skusValidated && (
                  <span className={`text-sm font-medium ${hasExistingSKUs ? 'text-red-600' : 'text-green-600'}`}>
                    {hasExistingSKUs ? `❌ ${invalidSKUs.length} SKU(s) exist` : '✅ All SKUs available'}
                  </span>
                )}
              </div>
            </div>
            <div className="overflow-x-auto">
              <table className="w-full ">
                <thead className="bg-gray-50">
                  {table.getHeaderGroups().map((headerGroup) => (
                    <tr key={headerGroup.id}>
                      {headerGroup.headers.map((header) => (
                        <th
                          key={header.id}
                          className="px-4 py-3 text-left text-sm font-medium text-gray-700"
                        >
                          {flexRender(
                            header.column.columnDef.header,
                            header.getContext()
                          )}
                        </th>
                      ))}
                    </tr>
                  ))}
                </thead>
                <tbody>
                  {table.getRowModel().rows.map((row) => (
                    <tr key={row.id} className="border-t border-gray-200">
                      {row.getVisibleCells().map((cell) => (
                        <td
                          key={cell.id}
                          className="px-4 py-3 text-sm text-gray-900"
                        >
                          {flexRender(
                            cell.column.columnDef.cell,
                            cell.getContext()
                          )}
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </Col>
    </Row>
  );
};

export default BulkInputSKUsStep;
